import { PERM_PER_FUNCTIONS } from 'src/utils/roleRules';
import { RootState, store } from 'src/app/store';
import { getProjectTreeApiSlice } from 'src/api/v1/get-project-tree-ApiSlice';

export function hasPermissionForFuncInProject(functionName: string, projectId: number | string | undefined): boolean {
  if (!functionName) {
    console.debug('got undefined for functionName');
    return false;
  }
  if (!projectId) {
    console.debug('got undefined for projectId');
    return false;
  }
  if (!(functionName in PERM_PER_FUNCTIONS)) {
    console.debug('tried to get permission for non existing func name', functionName);
    return false;
  }

  const role = roleInProject(Number(projectId));
  if (!role) {
    console.debug('No role returned for projectId:', projectId);
    return false;
  }

  return hasPermissionForFuncInRole(functionName, role);
}

function roleInProject(projectId: any): string {
  let projectTreeProject = getProjectTreeApiSlice.endpoints.getProjectTreeProject.select(+projectId)(store.getState() as RootState).data!!;
  var projPropNodeId = 'project_general_properties_' + projectId;
  const projectGeneralPropertiesNode =
      projectTreeProject.find(node => node.id === projPropNodeId)!!;
  return projectGeneralPropertiesNode['user-role-name']!!;
}


export function hasPermissionForFuncInRole(functionName: string, role: string): boolean {
  if (!role) {
    console.log('couldnt find role for projectId', role);
    return false;
  } else { // @ts-ignore
    if (!(role in PERM_PER_FUNCTIONS[functionName])) {
      console.debug('tried to get permission for non existing role', role);
      return false;
    } else {
      // @ts-ignore
      return PERM_PER_FUNCTIONS[functionName][role];
    }
  }

}



